/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaBancoVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaBanco: React.FunctionComponent<ITablaBancoVistaProps & InjectedIntlProps> = ({
    bancos,
    cargarBanco,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={bancos}
            actions={acciones(manejarFormulario, cargarBanco, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaBanco);
